export default "__VITE_ASSET__96100f13__"